import {
  CREATE_ROOM_REQUEST,
  CREATE_ROOM_SUCCESS,
  CREATE_ROOM_FAIL,
  CREATE_ROOM_RESET,
  GET_ROOM_BY_SLUG_REQUEST,
  GET_ROOM_BY_SLUG_SUCCESS,
  GET_ROOM_BY_SLUG_FAIL,
  GET_ROOM_BY_SLUG_RESET,
  GET_BOARD_ROOMS_REQUEST,
  GET_BOARD_ROOMS_SUCCESS,
  GET_BOARD_ROOMS_FAIL,
} from "./MeetingRoomTypes";

const initialState = {
  createLoading: false,
  createError: null,
  createdRoom: null,

  roomBySlug: null,
  roomBySlugLoading: false,
  roomBySlugError: null,

  boardRooms: [],
  boardRoomsLoading: false,
  boardRoomsError: null,
};

export const meetingRoomReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_ROOM_REQUEST:
      return {
        ...state,
        createLoading: true,
        createError: null,
      };
    case CREATE_ROOM_SUCCESS:
      return {
        ...state,
        createLoading: false,
        createError: null,
        createdRoom: action.payload,
      };
    case CREATE_ROOM_FAIL:
      return {
        ...state,
        createLoading: false,
        createError: action.payload,
        createdRoom: null,
      };
    case CREATE_ROOM_RESET:
      return {
        ...state,
        createLoading: false,
        createError: null,
        createdRoom: null,
      };

    case GET_ROOM_BY_SLUG_REQUEST:
      return {
        ...state,
        roomBySlug: null,
        roomBySlugLoading: true,
        roomBySlugError: null,
      };
    case GET_ROOM_BY_SLUG_SUCCESS:
      return {
        ...state,
        roomBySlug: action.payload,
        roomBySlugLoading: false,
        roomBySlugError: null,
      };
    case GET_ROOM_BY_SLUG_FAIL:
      return {
        ...state,
        roomBySlug: null,
        roomBySlugLoading: false,
        roomBySlugError: action.payload,
      };
    case GET_ROOM_BY_SLUG_RESET:
      return {
        ...state,
        roomBySlug: null,
        roomBySlugLoading: false,
        roomBySlugError: null,
      };

    case GET_BOARD_ROOMS_REQUEST:
      return {
        ...state,
        boardRoomsLoading: true,
        boardRoomsError: null,
      };
    case GET_BOARD_ROOMS_SUCCESS:
      return {
        ...state,
        boardRooms: action.payload,
        boardRoomsLoading: false,
        boardRoomsError: null,
      };
    case GET_BOARD_ROOMS_FAIL:
      return {
        ...state,
        boardRooms: [],
        boardRoomsLoading: false,
        boardRoomsError: action.payload,
      };

    default:
      return state;
  }
};
